import React from "react";
import { useLanguage } from "../../Context/LanguageContext.jsx";
import extraInfo from "../../myData/extraInfo.js";
import "../ExtraInfo/ExtraInfo.css";
import { GiLoveMystery } from "react-icons/gi";
import { MdLanguage } from "react-icons/md";

function ExtraInfo() {
  const { language } = useLanguage();

  const getDirection = () => {
    return language === "arabic" ? "rtl" : "ltr";
  };

  return (
    <div className={language === "arabic" ? "container arabic" : "container"}>
      <h2
        className={language === "arabic" ? "page-title arabic" : "page-title"}
      >
        {language === "english"
          ? "Extra information"
          : language === "dutch"
          ? ""
          : "معلومات اضافية"}
      </h2>
      <div dir={getDirection()} className="hobbies-container">
        <h3>{language === "arabic" ? "الهوايات" : "Hobbies"}</h3>
        <ul>
          {extraInfo.hobbies[language].map((hobby, index) => (
            <li key={index}>
              <GiLoveMystery /> <p>{hobby}</p>
            </li>
          ))}
        </ul>
      </div>
      <div dir={getDirection()} className="language-container">
        <h3>{language === "arabic" ? "اللغات" : "Languages"}</h3>
        <ul>
          {extraInfo.languages[language].map((language, index) => (
            <li key={index}>
              <MdLanguage /> <p>{language}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default ExtraInfo;
